var map = {
	"./4dd59c7d-1f52-46a8-a7ed-0b6a4beeec3c.jpg": 6075,
	"./5ff3bd89-8271-49e0-9f2c-b5c3c03cfb75.jpg": 1677,
	"./bell.png": 135,
	"./contentdata": 5946,
	"./contentdata.json": 5946,
	"./fear.png": 1162,
	"./games-icon.png": 1529,
	"./goal.png": 8413,
	"./home-icon.png": 1395,
	"./info.png": 6768,
	"./jam_menu.png": 6422,
	"./jdo.png": 4939,
	"./jido2.png": 5168,
	"./learn.png": 5968,
	"./nurture.png": 8823,
	"./parta_q0_cars_motorbikes.png": 110,
	"./parta_q10_experiments.png": 7456,
	"./parta_q11_teach.png": 1046,
	"./parta_q12_helping.png": 1545,
	"./parta_q13_animals.png": 4452,
	"./parta_q14_office.png": 3026,
	"./parta_q15_sell.png": 7449,
	"./parta_q16_writing.png": 5706,
	"./parta_q17_science.png": 4629,
	"./parta_q18_responsibilities.png": 3996,
	"./parta_q19_heal.png": 1111,
	"./parta_q1_puzzles.png": 4919,
	"./parta_q20_workings.png": 701,
	"./parta_q21_assemble.png": 8918,
	"./parta_q22_creative.png": 8772,
	"./parta_q23_details.png": 40,
	"./parta_q24_analyze.png": 789,
	"./parta_q25_filing_typing_organizing.png": 4778,
	"./parta_q26_instrument_sing.png": 8872,
	"./parta_q27_cultures_people.png": 9451,
	"./parta_q28_business.png": 4015,
	"./parta_q29_cook.png": 6362,
	"./parta_q2_team_work.png": 7878,
	"./parta_q30_act.png": 4726,
	"./parta_q31_practical.png": 970,
	"./parta_q32_numbers.png": 5550,
	"./parta_q33_social.png": 9332,
	"./parta_q34_records.png": 8092,
	"./parta_q35_lead.png": 2957,
	"./parta_q36_outdoors.png": 4009,
	"./parta_q37_indoors.png": 305,
	"./parta_q38_mathematics.png": 5736,
	"./parta_q39_help_people.png": 6774,
	"./parta_q3_independent.png": 648,
	"./parta_q40_draw_paint_crafts.png": 5620,
	"./parta_q41_public_speaking.png": 766,
	"./parta_q4_ambitious.png": 1486,
	"./parta_q5_organized.png": 9401,
	"./parta_q6_building.png": 9687,
	"./parta_q7_art_music.png": 5429,
	"./parta_q8_instructions.png": 5586,
	"./parta_q9_persuade.png": 7645,
	"./partb_q0_confidence.png": 2322,
	"./partb_q10_waste_day.png": 5994,
	"./partb_q11_control.png": 149,
	"./partb_q12_good_morning.png": 9195,
	"./partb_q13_bothersome.png": 7718,
	"./partb_q14_future_now.png": 7023,
	"./partb_q15_role_model.png": 5350,
	"./partb_q16_self_goal.png": 1077,
	"./partb_q17_money.png": 8544,
	"./partb_q18_party_time.png": 9267,
	"./partb_q1_organizing_it.png": 3799,
	"./partb_q2_get_together.png": 6505,
	"./partb_q3_abuse_self.png": 5848,
	"./partb_q4_classroom.png": 6237,
	"./partb_q5_table_tennis.png": 9703,
	"./partb_q6_progress.png": 6345,
	"./partb_q7_mumbai_goa.png": 1380,
	"./partb_q8_fear_ego.png": 2834,
	"./partb_q9_strive.png": 5468,
	"./programs-icon.png": 645,
	"./programs-icon1.png": 5656,
	"./shine.png": 1963,
	"./storyoflifelogo.png": 1821,
	"./survey.png": 4762,
	"./tanchateens_logo.png": 7146,
	"./whatsapp-icon.png": 6254,
	"./wings.png": 7790,
	"./yancha-eight-wonder.png": 1190,
	"./yancha-kids-front.png": 4092,
	"./yancha-one-on-one.png": 7360,
	"./yancha-teens-front.png": 8688,
	"./yancha_logo.png": 8070,
	"./yancha_pkt_logo.png": 6710,
	"./yancha_sol_back.jpg": 6803,
	"./yancha_sol_declaration.jpg": 3604,
	"./yancha_sol_front.jpg": 2081,
	"./yanda_teen_logo.png": 1644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;